module.exports = __webpack_public_path__ + "static/media/glassMainImg.4b7230ef.png";